import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFourChildren = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 67 75",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "two-children",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "child",
				children: /* @__PURE__ */ _jsxs("svg", {
					width: 32,
					height: 33,
					viewBox: "0 0 32 33",
					fill: "none",
					xmlns: "http://www.w3.org/2000/svg",
					ref,
					"aria-labelledby": titleId,
					...props,
					children: [
						title ? /* @__PURE__ */ _jsx("title", {
							id: titleId,
							children: title
						}) : null,
						/* @__PURE__ */ _jsxs("g", {
							clipPath: "url(#clip0)",
							children: [
								/* @__PURE__ */ _jsx("path", {
									d: "M27.0946 20.9113C29.8485 20.6712 31.9998 18.7845 31.9998 16.4999C31.9998 14.2152 29.8485 12.3285 27.0946 12.0884C26.0269 9.40587 24.0075 7.18664 21.4342 5.86908C21.3655 2.93267 18.9723 0.5 15.9999 0.5C13.0297 0.5 10.6343 2.92998 10.5656 5.86915C7.99225 7.1867 5.97283 9.40599 4.90521 12.0885C2.15123 12.3285 0 14.2152 0 16.4999C0 18.7847 2.15155 20.6715 4.90577 20.9113C5.7937 23.1369 7.35557 25.0646 9.34024 26.4058C7.72913 27.6727 6.53076 29.3579 5.90408 31.2703C5.74283 31.7623 6.01102 32.2919 6.50301 32.4531C6.99501 32.6143 7.52457 32.3461 7.68581 31.8542C8.27756 30.0485 9.50043 28.4866 11.1532 27.4111C14.3454 28.8338 17.9594 28.749 21.0184 27.3324C22.7344 28.4091 24.0011 29.9989 24.6089 31.8541C24.7701 32.3462 25.2996 32.6143 25.7917 32.4531C26.2837 32.2919 26.5519 31.7624 26.3907 31.2703C25.7448 29.2991 24.4985 27.5764 22.8184 26.2996C24.6728 25.0088 26.204 23.1545 27.0946 20.9113ZM30.1248 16.4999C30.1248 17.5951 29.0925 18.5557 27.6927 18.9134C28.0185 17.3283 28.0192 15.6748 27.6927 14.0864C29.0925 14.444 30.1248 15.4047 30.1248 16.4999ZM15.9999 2.37499C17.8044 2.37499 19.2998 3.74716 19.5312 5.52002C17.2892 5.71271 15.4319 7.26207 14.7964 9.35537C13.407 8.86125 12.4374 7.53882 12.4374 5.99989C12.4374 4.00116 14.0355 2.37499 15.9999 2.37499ZM1.87499 16.4999C1.87499 15.4047 2.90729 14.444 4.30709 14.0863C3.98122 15.6714 3.98053 17.3249 4.30709 18.9134C2.90729 18.5557 1.87499 17.5951 1.87499 16.4999ZM20.6296 25.4366C15.2359 28.238 8.52387 25.6771 6.45439 19.6914C4.95102 15.1938 6.79826 10.2537 10.8799 7.83657C11.5642 9.75412 13.2923 11.1824 15.4253 11.4069C15.9416 11.4612 16.4034 11.0855 16.4561 10.5699C16.6514 8.65837 18.3215 7.23932 20.2693 7.38638C24.8515 9.53605 27.1759 14.813 25.5453 19.6913C24.639 22.319 22.8196 24.2996 20.6296 25.4366Z",
									fill: "#808080"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M13.6985 15.3949C14.0646 15.0288 14.0646 14.4353 13.6985 14.0691C12.3551 12.7257 10.1807 12.7256 8.83709 14.0691C8.47097 14.4353 8.47097 15.0288 8.83709 15.3949C9.20316 15.7611 9.79678 15.7611 10.1629 15.3949C10.7736 14.7843 11.7619 14.7843 12.3726 15.3949C12.7387 15.761 13.3323 15.7611 13.6985 15.3949Z",
									fill: "#808080"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M23.1985 14.0691C21.8551 12.7257 19.6807 12.7256 18.3371 14.0691C17.971 14.4353 17.971 15.0288 18.3371 15.3949C18.7032 15.7611 19.2968 15.7611 19.6629 15.3949C20.2736 14.7843 21.2619 14.7843 21.8726 15.3949C22.2387 15.761 22.8322 15.7611 23.1984 15.3949C23.5646 15.0289 23.5646 14.4353 23.1985 14.0691Z",
									fill: "#808080"
								}),
								/* @__PURE__ */ _jsx("path", {
									d: "M17.8122 20.3366C16.8131 21.3357 15.1874 21.3357 14.1882 20.3366C13.8222 19.9705 13.2286 19.9705 12.8624 20.3366C12.4964 20.7027 12.4964 21.2963 12.8624 21.6624C14.5926 23.3925 17.4078 23.3925 19.138 21.6624C19.5041 21.2963 19.5041 20.7027 19.138 20.3366C18.7718 19.9705 18.1783 19.9705 17.8122 20.3366Z",
									fill: "#808080"
								})
							]
						}),
						/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
							id: "clip0",
							children: /* @__PURE__ */ _jsx("rect", {
								width: 32,
								height: 32,
								fill: "white",
								transform: "translate(0 0.5)"
							})
						}) })
					]
				})
			}), /* @__PURE__ */ _jsx("use", {
				href: "#child",
				x: 35
			})]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#two-children",
			y: 40
		})
	]
});
const ForwardRef = forwardRef(SvgFourChildren);
export default ForwardRef;
